import EditBooking from './EditBooking';

export default EditBooking;
